
import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail,
    IonListHeader,
    IonText,
    useIonRouter
} from '@ionic/react';
import { giftOutline, image, arrowForwardCircleOutline } from 'ionicons/icons';
import React, { Component }  from 'react';
import { chevronForwardOutline } from "ionicons/icons";
import { MsgThread } from "../data/message";


interface ThreadItemProp {
    thread: MsgThread;
}
  
const MessageThread : React.FC<ThreadItemProp> = ({ thread }) => {

    //	Initializing our router
	const router = useIonRouter();

    // go to message
    const ClickMsg = () => {
        if (thread.id == 3)
            router.push("/random_chat", "forward", "push");
        else
            router.push("/chatmsg/" + thread.id + "/thread", "forward", "push");
    }

    if (thread.header)
    {
        return (
            <IonListHeader className="msg-header">
                <IonText className="msg-header-text">{thread.header}</IonText>
            </IonListHeader>
        );
    }

    return (
        <IonItem lines="none" onClick={ClickMsg}>
            <IonAvatar slot="start">
                <img src={thread.avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
            </IonAvatar>
            {
                    thread.read == "yes" ?
            <IonLabel className="ion-text-wrap">
                { thread.tag != "" ? <div><IonText className="thread-tag" color="medium"><small>{thread.tag}</small></IonText></div> : <div/> }
                <div className="msg-thread">{thread.title}</div>                
                <IonNote className="ion-text-nowrap">{ thread.preview == "" ? "..." : thread.preview }</IonNote>
            </IonLabel>
                :
            <IonLabel className="ion-text-wrap">
                { thread.tag != "" ? <div><IonText className="thread-tag" color="medium"><small>{thread.tag}</small></IonText></div> : <div/> }
                <div className="msg-thread"><b>{thread.title}</b></div>                
                <IonNote className="ion-text-nowrap"><b>"{ thread.preview == "" ? "..." : thread.preview }"</b></IonNote>
            </IonLabel>
            }
            <IonIcon icon={chevronForwardOutline} slot="end" />
        </IonItem>
    );
};
  
export default MessageThread;